<div class="ft-form">
    <div class="content">
        <div class="ft-form-row">
            <div class="lable-contributors">{{"about_us.lbl_contributors" | translate}}</div>
        </div>

        <div *ngFor= "let contributorSection of this.contributorSections">
            <div class="time-period" >{{contributorSection.timePeriod | translate}}</div>
            <!-- Contributor section description -->
            <div class="ft-form-row">
                <div class="lable-text-mid" style="text-align: justify;">{{contributorSection.description | translate}}</div> 
            </div>
    
            <div class="contributorSection-container"> 
                <div *ngFor= "let contributor of contributorSection.contributors"> 
                    <app-contributor-section [contributor] = "contributor"></app-contributor-section> 
                </div>                
            </div>
            <hr style="color: #87b808;column-span: all;">
        </div>
    </div>

    <div class="footer">
        <button class="ft-btn ft-btn-active-not-selected" (click)="ok()">{{"lbl_ok" | translate}}</button>
    </div>
</div>